module.exports = __webpack_public_path__ + "b03156a6eb8b94dccc8d302a0be0b387.svg";